import { POINTS_ENABLED } from '@/config/consts'

interface PointsVisibilityParams {
  hasHypurrPoints: boolean
  hasPartnerPoints: boolean
  isEarnVault: boolean
}

export function getPointsVisibility({
  hasHypurrPoints,
  hasPartnerPoints,
  isEarnVault,
}: PointsVisibilityParams) {
  const hasEarnVaultPoints = isEarnVault && POINTS_ENABLED
  const hasVisiblePoints = hasHypurrPoints || hasPartnerPoints || hasEarnVaultPoints

  return { hasEarnVaultPoints, hasVisiblePoints }
}
